import React, { useState } from 'react';

const ARTICLES = [
  {
    id: 1,
    title: 'How to Reset Your Password',
    category: 'Account',
    views: 342,
    updated: '2026-04-15',
    content:
      'Follow these steps to reset your password: 1. Click the "Forgot Password" link on the login page...',
    excerpt:
      'Step-by-step guide to reset your account password securely.',
  },
  {
    id: 2,
    title: 'Understanding SLA Policies',
    category: 'Policies',
    views: 198,
    updated: '2026-04-18',
    content:
      'Service Level Agreement (SLA) defines our commitment to response and resolution times...',
    excerpt:
      'Learn about our Service Level Agreement and support response times.',
  },
  {
    id: 3,
    title: 'Troubleshooting Connection Issues',
    category: 'Technical',
    views: 526,
    updated: '2026-04-10',
    content:
      'If you are unable to connect to our service, try these troubleshooting steps...',
    excerpt:
      'Common connection issues and how to resolve them.',
  },
  {
    id: 4,
    title: 'API Integration Guide',
    category: 'Technical',
    views: 287,
    updated: '2026-04-20',
    content:
      'Our API allows you to integrate our services into your applications...',
    excerpt:
      'Complete guide to integrating our API into your application.',
  },
  {
    id: 5,
    title: 'Billing and Payment FAQ',
    category: 'Billing',
    views: 401,
    updated: '2026-04-12',
    content:
      'Common questions about billing, invoices, and payment methods...',
    excerpt:
      'Frequently asked questions about billing and payments.',
  },
  {
    id: 6,
    title: 'Security Best Practices',
    category: 'Security',
    views: 612,
    updated: '2026-04-19',
    content:
      'Protect your account with these security best practices...',
    excerpt:
      'Essential security tips to keep your account safe.',
  },
];

export default function KnowledgeBasePage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [showCategories, setShowCategories] = useState(false);

  const categories = [
    'All',
    ...new Set(ARTICLES.map((a) => a.category)),
  ];

  const filteredArticles = ARTICLES.filter((article) => {
    const matchSearch =
      article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      article.excerpt.toLowerCase().includes(searchTerm.toLowerCase());

    const matchCategory =
      selectedCategory === 'All' || article.category === selectedCategory;

    return matchSearch && matchCategory;
  });

  if (selectedArticle) {
    const article = ARTICLES.find((a) => a.id === selectedArticle);
    return (
      <div style={styles.container}>
        <style>{responsiveCSS}</style>
        {/* Header */}
        <header style={styles.header}>
          <div style={styles.headerContent}>
            <button
              onClick={() => setSelectedArticle(null)}
              style={styles.backBtn}
              title="Back to articles"
            >
              ← Back
            </button>
            <h1 style={styles.title}>{article.title}</h1>
          </div>
        </header>

        {/* Article Detail */}
        <main style={styles.content}>
          <div style={styles.articleWrapper}>
            <div style={styles.articleMeta}>
              <span style={styles.categoryTag}>{article.category}</span>
              <span style={styles.viewCount}>👁️ {article.views}</span>
              <span style={styles.updated}>
                {article.updated}
              </span>
            </div>

            <p style={styles.articleContent}>{article.content}</p>

            <div style={styles.articleActions}>
              <button style={styles.actionBtn}>👍 Helpful</button>
              <button style={styles.actionBtn}>👎 Not Helpful</button>
              <button style={styles.actionBtn}>🆘 Help?</button>
            </div>

            <div style={styles.relatedArticles}>
              <h3 style={styles.relatedTitle}>Related</h3>
              <div style={styles.relatedList}>
                {ARTICLES.filter((a) => a.id !== article.id)
                  .slice(0, 3)
                  .map((a) => (
                    <button
                      key={a.id}
                      onClick={() => setSelectedArticle(a.id)}
                      style={styles.relatedItem}
                    >
                      {a.title}
                    </button>
                  ))}
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <style>{responsiveCSS}</style>
      {/* Header */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <h1 style={styles.title}>Knowledge Base</h1>
          <p style={styles.subtitle}>
            Find answers to common issues
          </p>
        </div>
      </header>

      {/* Search */}
      <section style={styles.searchSection}>
        <div style={styles.searchBox}>
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
          <span style={styles.searchIcon}>🔍</span>
        </div>
      </section>

      {/* Main Content */}
      <main style={styles.content}>
        {/* Sidebar - Categories */}
        <aside style={styles.sidebar}>
          {/* Mobile Category Toggle */}
          <button
            onClick={() => setShowCategories(!showCategories)}
            style={styles.categoryToggle}
            className="mobile-only"
          >
            📁 Categories {showCategories ? '▼' : '▶'}
          </button>

          <div
            style={{
              ...styles.categoryListWrapper,
              ...(showCategories
                ? styles.categoryListWrapperOpen
                : {}),
            }}
          >
            <h3 style={styles.sidebarTitle}>Categories</h3>
            <div style={styles.categoryList}>
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => {
                    setSelectedCategory(cat);
                    setShowCategories(false);
                  }}
                  style={{
                    ...styles.categoryBtn,
                    ...(selectedCategory === cat
                      ? styles.categoryBtnActive
                      : {}),
                  }}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          <div style={styles.helpSection}>
            <h4 style={styles.helpTitle}>Need Help?</h4>
            <button style={styles.supportBtn}>
              Contact Support
            </button>
          </div>
        </aside>

        {/* Articles List */}
        <section style={styles.articlesSection}>
          <div style={styles.articlesHeader}>
            <h2 style={styles.articlesSectionTitle}>
              Articles {selectedCategory !== 'All' && `(${selectedCategory})`}
            </h2>
            <span style={styles.articleCount}>
              {filteredArticles.length}
            </span>
          </div>

          {filteredArticles.length === 0 ? (
            <div style={styles.emptyState}>
              <p style={styles.emptyIcon}>🔍</p>
              <p style={styles.emptyText}>No articles found</p>
            </div>
          ) : (
            <div style={styles.articlesList}>
              {filteredArticles.map((article) => (
                <article
                  key={article.id}
                  onClick={() => setSelectedArticle(article.id)}
                  style={styles.articleCard}
                  role="button"
                  tabIndex={0}
                >
                  <div style={styles.articleCardHeader}>
                    <h3 style={styles.articleTitle}>
                      {article.title}
                    </h3>
                    <span style={styles.readMore}>→</span>
                  </div>
                  <p style={styles.articleExcerpt}>
                    {article.excerpt}
                  </p>
                  <div style={styles.articleCardFooter}>
                    <span style={styles.cardCategory}>
                      {article.category}
                    </span>
                    <span style={styles.cardViews}>
                      👁️ {article.views}
                    </span>
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

const responsiveCSS = `
  @media (max-width: 768px) {
    .mobile-only {
      display: block !important;
    }
  }
  
  @media (max-width: 768px) {
    main[style] {
      grid-template-columns: 1fr !important;
    }
  }
`;

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f5f7fa',
    paddingBottom: '64px',
  },

  // Header
  header: {
    backgroundColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    padding: '2rem 1.5rem',
    textAlign: 'center',
  },
  headerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  title: {
    fontSize: 'clamp(1.75rem, 5vw, 2.25rem)',
    fontWeight: '700',
    margin: '0 0 0.5rem 0',
  },
  subtitle: {
    fontSize: 'clamp(0.9rem, 2vw, 1rem)',
    color: 'rgba(255, 255, 255, 0.9)',
    margin: 0,
  },
  backBtn: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '0.625rem 1rem',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: '500',
    marginBottom: '1rem',
    pointerEvents: 'auto',
  },

  // Search Section
  searchSection: {
    backgroundColor: '#ffffff',
    padding: 'clamp(1.5rem, 4vw, 2rem)',
    borderBottom: '1px solid #e8eef5',
  },
  searchBox: {
    maxWidth: '1200px',
    margin: '0 auto',
    position: 'relative',
  },
  searchInput: {
    width: '100%',
    padding: '0.875rem 1rem 0.875rem 2.75rem',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    fontSize: 'clamp(0.875rem, 2vw, 1rem)',
    outline: 'none',
    transition: 'all 0.2s',
    pointerEvents: 'auto',
    boxSizing: 'border-box',
  },
  'searchInput:focus': {
    borderColor: '#1e3a8a',
    boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
  },
  searchIcon: {
    position: 'absolute',
    left: '0.875rem',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '1.125rem',
  },

  // Content Layout
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: 'clamp(1rem, 3vw, 2rem)',
    display: 'grid',
    gridTemplateColumns: 'minmax(260px, 280px) 1fr',
    gap: 'clamp(1rem, 3vw, 2rem)',
  },

  // Sidebar
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  categoryToggle: {
    display: 'none',
    width: '100%',
    backgroundColor: '#ffffff',
    border: '1px solid #e8eef5',
    borderRadius: '6px',
    padding: '0.75rem 1rem',
    fontSize: '0.95rem',
    fontWeight: '600',
    color: '#1f2937',
    cursor: 'pointer',
    pointerEvents: 'auto',
    textAlign: 'left',
    transition: 'all 0.2s',
  },
  'categoryToggle:hover': {
    backgroundColor: '#f9fafb',
  },
  categoryListWrapper: {
    display: 'block',
  },
  categoryListWrapperOpen: {
    display: 'block',
  },
  sidebarTitle: {
    fontSize: 'clamp(0.9rem, 2vw, 1rem)',
    fontWeight: '700',
    color: '#1f2937',
    margin: 0,
    marginBottom: '0.5rem',
  },
  categoryList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginBottom: '1rem',
  },
  categoryBtn: {
    backgroundColor: '#ffffff',
    border: '1px solid #e8eef5',
    borderRadius: '6px',
    padding: '0.75rem 1rem',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#6b7280',
    cursor: 'pointer',
    transition: 'all 0.2s',
    pointerEvents: 'auto',
    textAlign: 'left',
  },
  categoryBtnActive: {
    backgroundColor: '#1e3a8a',
    borderColor: '#1e3a8a',
    color: 'white',
  },
  helpSection: {
    backgroundColor: '#f0f9ff',
    border: '1px solid #bfdbfe',
    borderRadius: '8px',
    padding: '1.25rem',
    textAlign: 'center',
  },
  helpTitle: {
    fontSize: '0.875rem',
    fontWeight: '700',
    color: '#1e3a8a',
    margin: '0 0 0.75rem 0',
  },
  supportBtn: {
    backgroundColor: '#0ea5e9',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '0.625rem 1rem',
    fontSize: '0.875rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background 0.2s',
    pointerEvents: 'auto',
    width: '100%',
  },
  'supportBtn:hover': {
    backgroundColor: '#0284c7',
  },

  // Articles Section
  articlesSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  articlesHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '1rem',
  },
  articlesSectionTitle: {
    fontSize: 'clamp(1.25rem, 4vw, 1.5rem)',
    fontWeight: '700',
    color: '#1f2937',
    margin: 0,
  },
  articleCount: {
    fontSize: '0.875rem',
    color: '#6b7280',
    fontWeight: '600',
    backgroundColor: '#f3f4f6',
    padding: '0.25rem 0.75rem',
    borderRadius: '4px',
  },

  emptyState: {
    textAlign: 'center',
    padding: 'clamp(2rem, 5vw, 4rem)',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    border: '1px solid #e8eef5',
  },
  emptyIcon: {
    fontSize: 'clamp(2rem, 6vw, 3rem)',
    margin: 0,
  },
  emptyText: {
    fontSize: '1.125rem',
    fontWeight: '600',
    color: '#1f2937',
    margin: '0.75rem 0 0 0',
  },

  // Articles List
  articlesList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(clamp(280px, 50vw, 320px), 1fr))',
    gap: '1.5rem',
  },
  articleCard: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    border: '1px solid #e8eef5',
    padding: 'clamp(1rem, 3vw, 1.5rem)',
    cursor: 'pointer',
    transition: 'all 0.2s',
    pointerEvents: 'auto',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    flexDirection: 'column',
  },
  'articleCard:hover': {
    borderColor: '#1e3a8a',
    boxShadow: '0 8px 16px rgba(59, 130, 246, 0.12)',
    transform: 'translateY(-4px)',
  },

  articleCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '1rem',
    gap: '0.75rem',
  },
  articleTitle: {
    fontSize: 'clamp(0.95rem, 2.5vw, 1.025rem)',
    fontWeight: '700',
    color: '#1f2937',
    margin: 0,
    flex: 1,
    lineHeight: '1.4',
  },
  readMore: {
    fontSize: '1.25rem',
    color: '#1e3a8a',
    fontWeight: '600',
    flexShrink: 0,
  },

  articleExcerpt: {
    fontSize: 'clamp(0.8rem, 2vw, 0.875rem)',
    color: '#6b7280',
    lineHeight: '1.5',
    margin: '0 0 1rem 0',
    flex: 1,
  },

  articleCardFooter: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    paddingTop: '1rem',
    borderTop: '1px solid #f3f4f6',
    fontSize: 'clamp(0.7rem, 1.5vw, 0.75rem)',
    color: '#6b7280',
    flexWrap: 'wrap',
  },
  cardCategory: {
    backgroundColor: '#f3f4f6',
    padding: '0.25rem 0.5rem',
    borderRadius: '3px',
    fontWeight: '500',
  },
  cardViews: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
  },

  // Article Detail
  articleWrapper: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: 'clamp(1.5rem, 4vw, 2rem)',
    border: '1px solid #e8eef5',
    maxWidth: '800px',
    margin: '0 auto',
    width: '100%',
    boxSizing: 'border-box',
  },
  articleMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
    marginBottom: '2rem',
    paddingBottom: '1.5rem',
    borderBottom: '1px solid #e5e7eb',
    flexWrap: 'wrap',
    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
  },
  categoryTag: {
    backgroundColor: '#f3f4f6',
    color: '#374151',
    padding: '0.375rem 0.75rem',
    borderRadius: '6px',
    fontWeight: '600',
  },
  viewCount: {
    color: '#6b7280',
  },
  updated: {
    color: '#6b7280',
  },
  articleContent: {
    fontSize: 'clamp(0.95rem, 2.5vw, 1rem)',
    lineHeight: '1.8',
    color: '#374151',
    marginBottom: '2rem',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
  },
  articleActions: {
    display: 'flex',
    gap: '0.75rem',
    marginBottom: '2rem',
    paddingBottom: '2rem',
    borderBottom: '1px solid #e5e7eb',
    flexWrap: 'wrap',
  },
  actionBtn: {
    backgroundColor: '#f3f4f6',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    padding: '0.625rem 1rem',
    fontSize: 'clamp(0.8rem, 2vw, 0.875rem)',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s',
    pointerEvents: 'auto',
    whiteSpace: 'nowrap',
  },
  'actionBtn:hover': {
    backgroundColor: '#e5e7eb',
    borderColor: '#9ca3af',
  },
  relatedArticles: {
    marginTop: '2rem',
  },
  relatedTitle: {
    fontSize: 'clamp(0.95rem, 2.5vw, 1rem)',
    fontWeight: '700',
    color: '#1f2937',
    marginBottom: '1rem',
  },
  relatedList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },
  relatedItem: {
    backgroundColor: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: '6px',
    padding: '0.75rem 1rem',
    fontSize: 'clamp(0.8rem, 2vw, 0.875rem)',
    color: '#1e3a8a',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s',
    pointerEvents: 'auto',
    textAlign: 'left',
  },
  'relatedItem:hover': {
    backgroundColor: '#f0f9ff',
    borderColor: '#1e3a8a',
  },
};
